module.exports = __webpack_public_path__ + "img/aParty_1208_G.c707d54f.jpg";